import { processMultipleWrappers, processTableContent } from '@src/utils/htmlProcessor';
import { useMemo } from 'react';

/**
 * Custom hook for processing HTML content with table wrapper
 *
 * @param content - HTML content to be processed
 * @param wrapperClass - CSS class for wrapper (optional)
 * @returns Processed HTML content
 */
export const useProcessedTableContent = (content: string, wrapperClass?: string): string => {
  return useMemo(() => {
    return processTableContent(content, wrapperClass);
  }, [content, wrapperClass]);
};

/**
 * Custom hook for processing HTML content with multiple wrappers
 *
 * @param content - HTML content to be processed
 * @param processors - Array of processor configurations
 * @returns Processed HTML content
 */
export const useProcessedContent = (
  content: string,
  processors: Array<{
    elementTag: string;
    wrapperClass: string;
  }>,
): string => {
  return useMemo(() => {
    return processMultipleWrappers(content, processors);
  }, [content, processors]);
};

export const defaultContentProcessors = [
  { elementTag: 'table', wrapperClass: 'table-wrapper overflow-x-auto' },
  { elementTag: 'img', wrapperClass: 'image-wrapper' },
];

/**
 * Custom hook for processing content with default processors (table + image)
 * Suitable for articles, events, support services, and other content types
 *
 * @param content - HTML content to be processed
 * @returns Processed HTML content with default wrappers
 */
export const useProcessedDefaultContent = (content: string): string => {
  return useProcessedContent(content, defaultContentProcessors);
};
